export default __webpack_public_path__ + "assets/images/a8cfb2dcc80a60b260a82f689077ec5c.svg";